// import React, { useState, useEffect } from 'react';

// import AirportServices from 'services/AirportServices';
// import useToggleDrawer from 'hooks/useToggleDrawer';
// import PageTitle from 'components/Typography/PageTitle';
// import MainDrawer from 'components/drawer/MainDrawer';
// import DataWrapper from './DataWrapper';
// import NotFound from 'components/table/NotFound'; // Import NotFound component
// import { useContext } from 'react';
// import { SidebarContext } from 'context/SidebarContext';
// import { FiRefreshCcw } from 'react-icons/fi';
// import DeleteModal from 'components/modal/DeleteModal';
// import useAsync from 'hooks/useAsync';
// import {
// 	Card,
// 	CardBody,
// 	Input,
// 	Table,
// 	TableCell,
// 	TableContainer,
// 	TableHeader,
// 	Button,
// } from '@windmill/react-ui';
// import AirportCityTable from 'components/airportcity/AirportCityTable';
// import { FiPlus } from 'react-icons/fi';
// import AirportDrawer from 'components/drawer/AirportDrawer';
// import sidebar from 'routes/sidebar';
// import ExportDataXlsx from 'components/common/ExportDataXlsx';

// const style = `.downloadbtn .svg-inline--fa {
//   font-size: 30px;
//   color:grey;
//   padding: 9px 10px;
//   margin: unset;
// }`;

// const AirportCity = () => {
// 	const adminInfo = localStorage.getItem('adminInfo')
// 		? JSON.parse(localStorage.getItem('adminInfo'))
// 		: null;
// 	const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
// 	const [searchText, setSearchText] = useState('');
// 	const { data, loading, error } = useAsync(() =>
// 		AirportServices.getAirportList()
// 	);
// 	const isDataArray = Array.isArray(data?.data); // Check if data is an array
// 	const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array
// 	const [status, setStatus] = useState('');

// 	const isAdmin = adminInfo?.id === 1;

// 	const hideView = isAdmin
// 		? true
// 		: adminInfo?.permission?.some(
// 				(perm) => perm.id_tab === 'airport city' && perm.view === 1
// 		  );

// 	const hideDelete = isAdmin
// 		? true
// 		: adminInfo?.permission?.some(
// 				(perm) => perm.id_tab === 'airport city' && perm.delete === 1
// 		  );

// 	const hideEdit = isAdmin
// 		? true
// 		: adminInfo?.permission?.some(
// 				(perm) => perm.id_tab === 'airport city' && perm.edit === 1
// 		  );

// 	const hideAdd = isAdmin
// 		? true
// 		: adminInfo?.permission?.some(
// 				(perm) => perm.id_tab === 'airport city' && perm.add === 1
// 		  );

// 	const hideExport = isAdmin
// 		? true
// 		: adminInfo?.permission?.some(
// 				(perm) => perm.id_tab === 'airport city' && perm.export === 1
// 		  );
// 	useEffect(() => {
// 		if (data?.status) {
// 			setStatus(data.status);
// 		} else {
// 			setStatus(false);
// 		}
// 	}, [data?.status]);

// 	const { title, serviceId } = useToggleDrawer();

// 	// Contains the column headers and table data in the required format for CSV

// 	const csvData = [
// 		['S.No','Airport Name', 'Code', 'Parking'],
// 		...safeData.map(({ airportname, airportcode, parking },index) => [
//             index + 1,
// 			airportname,
// 			airportcode,
// 			parking,
// 		]),
// 	];

// 	// const columns = [
// 	//   { name: "SL. No.", selector: (row) => row.id, cell },

// 	//   {
// 	//     name: "Airport Name",
// 	//     selector: (row) => row.airportname,
// 	//     sortable: true,
// 	//   },
// 	//   {
// 	//     name: "Airport Code",
// 	//     selector: (row) => row.airportcode,
// 	//     sortable: true,
// 	//   },
// 	//   {
// 	//     name: "City",
// 	//     selector: (row) => row.city_name,
// 	//     sortable: true,
// 	//   },
// 	//   {
// 	//     name: "Parking",
// 	//     selector: (row) => row.parking,
// 	//     sortable: true,
// 	//   },
// 	//   {
// 	//     name: "Actions",
// 	//     cell: (row) => (
// 	// <EditDeleteButton
// 	//   id={row.id}
// 	//   City={row}
// 	//   isSubmitting={isSubmitting}
// 	//   handleUpdate={handleUpdate}
// 	//   handleModalOpen={handleModalOpen}
// 	//   hideDelete={hideDelete}
// 	//   hideEdit={hideEdit}
// 	// />
// 	//     ),
// 	//   },
// 	// ];

// 	const searchTerms = searchText.toLowerCase().split(' ');

// 	const filteredData = safeData.filter((item) =>
// 		searchTerms.every(
// 			(term) =>
// 				(item.airportname !== null &&
// 					item.airportname.toLowerCase().includes(term)) ||
// 				(item.airportcode !== null &&
// 					item.airportcode.toLowerCase().includes(term))
// 		)
// 	);

// 	const handleRefresh = () => {
// 		setIsUpdate(true);
// 	};
// 	return (
// 		<>
// 			{hideView && (
// 				<>
// 					<DeleteModal id={serviceId} title={title} />

// 					<style>{style}</style>
// 					<PageTitle sidebar={sidebar().sidebar} />

// 					<MainDrawer>
// 						<AirportDrawer id={serviceId} />
// 					</MainDrawer>

// 					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
// 						<CardBody>
// 							<form className="gap-6 flex items-center">
// 								<div className="flex-1">
// 									<Input
// 										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
// 										type="search"
// 										name="search"
// 										value={searchText}
// 										autoComplete="off"
// 										onChange={(e) => setSearchText(e.target.value)}
// 										placeholder="Quick Search"
// 									/>
// 								</div>

// 								{hideAdd && (
// 									<Button
// 										onClick={toggleDrawer}
// 										className="w-56 rounded-md h-10"
// 									>
// 										<span className="mr-3">
// 											<FiPlus />
// 										</span>
// 										Add Airport
// 									</Button>
// 								)}

// 								{hideExport && (
// 									<ExportDataXlsx
// 										title="Airport List"
// 										exportDataXlsx={csvData}
// 										fileNames="Airport List"
// 									/>
// 								)}

// 								<FiRefreshCcw
// 									onClick={() => {
// 										handleRefresh();
// 									}}
// 									cursor="pointer"
// 								/>
// 							</form>
// 						</CardBody>
// 					</Card>

// 					{/* <div className="data-table-container mb-4">
//             {loading ? (
//               // Display a loading spinner or message while data is being fetched
//               <TableLoading row={12} col={6} width={190} height={20} />
//             ) : status === false || status === undefined ? (
//               <Somethingwentwrong title="Something went wrong, please try again later." />
//             ) : safeData.length > 0 ? (
//               <DataTable
//                 columns={columns}
//                 data={filteredData}
//                 onChangePage={handlePageChange}
//                 filterable
//                 sort
//                 customStyles={customStyles}
//               />
//             ) : (
//               // Show NotFound if there is no data
//               <NotFound title="There are no Airport Cities." />
//             )}
//           </div> */}

// 					{/* <div className="data-table-container"> */}
// 						<DataWrapper loading={loading} error={error} status={status}>
// 							{filteredData.length > 0 ? (
// 								<TableContainer
// 									className="mb-8"
// 									style={{
// 										maxHeight: '65vh',
// 										overflowY: 'scroll',
// 										scrollbarWidth: 'thin',
// 									}}
// 								>
// 									<Table>
// 										<TableHeader className="custom-table-header capitalize sticky top-0 z-10">
// 											<tr>
// 												<TableCell className="text-center">Sl.No.</TableCell>
// 												<TableCell className="text-center">
// 													Airport Name
// 												</TableCell>
// 												<TableCell className="text-center">
// 													Airport Code
// 												</TableCell>
// 												<TableCell className="text-center">City</TableCell>
// 												<TableCell className="text-center">Parking</TableCell>
// 												<TableCell className="text-center">Actions</TableCell>
// 											</tr>
// 										</TableHeader>

// 										<AirportCityTable
// 											airportcitydata={filteredData}
// 											hideEdit={hideEdit}
// 											hideDelete={hideDelete}
// 										/>
// 									</Table>
// 								</TableContainer>
// 							) : (
// 								// Show NotFound if there is no data
// 								<NotFound title="There are no AirportCitys." />
// 							)}
// 						</DataWrapper>
// 					{/* </div> */}
// 				</>
// 			)}
// 		</>
// 	);
// };

// export default AirportCity;

import React, { useState, useEffect } from "react";

import AirportServices from "services/AirportServices";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import MainDrawer from "components/drawer/MainDrawer";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound"; // Import NotFound component
import { useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import { FiRefreshCcw } from "react-icons/fi";
import DeleteModal from "components/modal/DeleteModal";
import useAsync from "hooks/useAsync";
import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import AirportCityTable from "components/airportcity/AirportCityTable";
import { FiPlus } from "react-icons/fi";
import AirportDrawer from "components/drawer/AirportDrawer";
import sidebar from "routes/sidebar";
import ExportDataXlsx from "components/common/ExportDataXlsx";

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color:grey;
  padding: 9px 10px;
  margin: unset;
}`;

const AirportCity = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
  const [searchText, setSearchText] = useState("");
  const { data, loading, error } = useAsync(() =>
    AirportServices.getAirportList(),
  );
  const isDataArray = Array.isArray(data?.data); // Check if data is an array
  const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array
  const [status, setStatus] = useState("");

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "airport city" && perm.view === 1,
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "airport city" && perm.delete === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "airport city" && perm.edit === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "airport city" && perm.add === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "airport city" && perm.export === 1,
      );
  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const { title, serviceId } = useToggleDrawer();

  // Contains the column headers and table data in the required format for CSV

  const csvData = [
    ["S.No", "Airport Name", "Code", "Parking"],
    ...safeData.map(({ airportname, airportcode, parking }, index) => [
      index + 1,
      airportname,
      airportcode,
      parking,
    ]),
  ];

  const updatedData = safeData.map((item, index) => {
    const parkingDetails = item?.parking_details || {};
    const vehicleParking = {};

    Object.values(parkingDetails).forEach((vehicle) => {
      const vehicleName = vehicle?.name || "Unknown";
      vehicleParking[vehicleName] = vehicle?.fee ?? "-";
    });

    return {
      "S.No.": index + 1,
      ID: item?.id ?? "-",

      "State ID": item?.state_id ?? "-",
      State: item?.state_name || "-",

      "City ID": item?.id_city ?? "-",
      City: item?.city_name || "-",

      "Airport Name": item?.airportname || "-",
      Code: item?.airportcode || "",
      Latitude: item?.latitude ?? "-",
      Longitude: item?.longitude ?? "-",

      ...vehicleParking,
    };
  });

  // const updatedData = safeData.map((item) => {
  //   const parking = Object.values(item?.parking_details || {})
  //     .map((vehicle) => `${vehicle?.name || "-"} - ${vehicle?.fee ?? "-"}`)
  //     .join(", ");

  //   return {
  //     "S.No.": item?.id ?? "-",
  //     "Airport Name": item?.airportname || "-",
  //     Code: item?.airportcode || "-",
  //     Parking: parking || "-",
  //     Latitude: item?.latitude || "-",
  //     Longitude: item?.longitude || "-",
  //   };
  // });

  // const columns = [
  //   { name: "SL. No.", selector: (row) => row.id, cell },

  //   {
  //     name: "Airport Name",
  //     selector: (row) => row.airportname,
  //     sortable: true,
  //   },
  //   {
  //     name: "Airport Code",
  //     selector: (row) => row.airportcode,
  //     sortable: true,
  //   },
  //   {
  //     name: "City",
  //     selector: (row) => row.city_name,
  //     sortable: true,
  //   },
  //   {
  //     name: "Parking",
  //     selector: (row) => row.parking,
  //     sortable: true,
  //   },
  //   {
  //     name: "Actions",
  //     cell: (row) => (
  // <EditDeleteButton
  //   id={row.id}
  //   City={row}
  //   isSubmitting={isSubmitting}
  //   handleUpdate={handleUpdate}
  //   handleModalOpen={handleModalOpen}
  //   hideDelete={hideDelete}
  //   hideEdit={hideEdit}
  // />
  //     ),
  //   },
  // ];

  const searchTerms = searchText.toLowerCase().split(" ");

  const filteredData = safeData.filter((item) =>
    searchTerms.every(
      (term) =>
        (item.airportname !== null &&
          item.airportname.toLowerCase().includes(term)) ||
        (item.airportcode !== null &&
          item.airportcode.toLowerCase().includes(term)),
    ),
  );

  const handleRefresh = () => {
    setIsUpdate(true);
  };
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <style>{style}</style>
          <PageTitle sidebar={sidebar().sidebar} />

          {/* <MainDrawer>
						<AirportDrawer id={serviceId} />
					</MainDrawer> */}

          <MainDrawer>
            <AirportDrawer key={serviceId ?? "new"} id={serviceId} />
          </MainDrawer>

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <form className="gap-6 flex items-center">
                <div className="flex-1">
                  <Input
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    value={searchText}
                    autoComplete="off"
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Quick Search"
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Airport
                  </Button>
                )}

                {hideExport && (
                  <ExportDataXlsx
                    title="Airport List"
                    exportDataXlsx={updatedData}
                    fileNames="Airport List"
                  />
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </form>
            </CardBody>
          </Card>

          {/* <div className="data-table-container mb-4">
            {loading ? (
              // Display a loading spinner or message while data is being fetched
              <TableLoading row={12} col={6} width={190} height={20} />
            ) : status === false || status === undefined ? (
              <Somethingwentwrong title="Something went wrong, please try again later." />
            ) : safeData.length > 0 ? (
              <DataTable
                columns={columns}
                data={filteredData}
                onChangePage={handlePageChange}
                filterable
                sort
                customStyles={customStyles}
              />
            ) : (
              // Show NotFound if there is no data
              <NotFound title="There are no Airport Cities." />
            )}
          </div> */}

          {/* <div className="data-table-container"> */}
          <DataWrapper loading={loading} error={error} status={status}>
            {filteredData.length > 0 ? (
              <TableContainer
                className="mb-8"
                style={{
                  maxHeight: "65vh",
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell className="text-center">Sl.No.</TableCell>
                      <TableCell className="text-center">
                        Airport Name
                      </TableCell>
                      <TableCell className="text-center">
                        Airport Code
                      </TableCell>
                      <TableCell className="text-center">City</TableCell>
                      <TableCell className="text-center">Latitude</TableCell>
                      <TableCell className="text-center">Longitude</TableCell>
                      <TableCell className="text-center">Parking</TableCell>
                      {(hideEdit||hideDelete)&&(
                         <TableCell className="text-center">Actions</TableCell>
                      )}
                     
                    </tr>
                  </TableHeader>

                  <AirportCityTable
                    airportcitydata={filteredData}
                    hideEdit={hideEdit}
                    hideDelete={hideDelete}
                  />
                </Table>
              </TableContainer>
            ) : (
              // Show NotFound if there is no data
              <NotFound title="There are no AirportCitys." />
            )}
          </DataWrapper>
          {/* </div> */}
        </>
      )}
    </>
  );
};

export default AirportCity;
